module.exports = __webpack_public_path__ + "static/img/drug.d1c4b68a.png";